import { getFileForNoteNumber, intervalLookup } from '../utils/chord-builder';
import { observable, computed } from 'mobx';
import { getRandomIndexFromProbabilityMass,
  getRandomInt } from '../utils/game-helpers';
import Stage from './stage-store';
class IntervalStore {

  possibleTunings = [-1.0, -0.5, 0.5, 1.0];
  @observable stages = [];
  @observable currentStage = null;
  passThresh = 3;

  @computed get total() {
    return this.stages.reduce( (acc, stage) => {
      if (stage.correct !== null) {
        acc++;
      }
      return acc;
    }, 0);
  }
  @computed get numberCorrect() {
    return this.stages.reduce( (acc, stage) => {
      if (stage.correct === true) {
        acc++;
      }
      return acc;
    }, 0);
  }

  @computed get percent() {
    if (this.total === 0) {
      return 0;
    }
    else {
      return Math.round(this.numberCorrect /
        this.total*100);
    }
  }
  getNewStage() {
    const newStage = this.getStage();
    this.currentStage = newStage;
    this.stages.push(newStage);
    return newStage;
  }

  getStage() {
    //note 75 for aug chord
    const base = getRandomInt(36, 75);
     // for now all intervals equal chance
    const upperShift = getRandomIndexFromProbabilityMass(
      [
        1/12,1/12,1/12,1/12,1/12,1/12,
        1/12,1/12,1/12,1/12,1/12,1/12,
      ]
    );
    const label = intervalLookup[upperShift];
    const files = [
      getFileForNoteNumber(base),
      getFileForNoteNumber(base+upperShift),
    ];
    const indexToDetune = getRandomInt(0, files.length);
    const chosenOffset = this.possibleTunings[Math.floor(Math.random()*this.possibleTunings.length)];
    const offSetArr = files.map( (_f, indx) => indx === indexToDetune? chosenOffset : 0 );
    return new Stage(files.reverse(), offSetArr, label);
  }
}
export const observableIntervalStore = new IntervalStore();



// WEBPACK FOOTER //
// ./src/stores/interval-store.js